export default __webpack_public_path__ + "static/media/step1.91d33ac2.webp";